/*------------------------------------*\
    calculator
\*------------------------------------*/
module.exports = function(){

    // Count animation based on StackOverflow answer here:
    // http://stackoverflow.com/questions/16994662/count-animation-from-number-a-to-b


    var duringAnim = false;

    function animateValueImproved(obj, end, duration) {
        // assumes integer values for start and end

        var start = parseInt(obj.text(), 10);
        var current = start;

        //var range = end > start ? (start - end) : (end - start);
        var range = end - start;
        // no timer shorter than 50ms (not really visible any way)
        var minTimer = 50;
        // calc step time to show all interediate values
        var stepTime = Math.abs(Math.floor(duration / range));

        // never go below minTimer
        stepTime = Math.max(stepTime, minTimer);

        // get current time and calculate desired end time
        var startTime = new Date().getTime();
        var endTime = startTime + duration;
        var timer;

        function run() {
            var now = new Date().getTime();
            var remaining = Math.max((endTime - now) / duration, 0);
            var value = Math.round(end - (remaining * range));
            obj.text(value)
            if (value == end) {
                clearInterval(timer);
            }
        }

        var timer = setInterval(run, stepTime);
        run();
    }

    function animateValue(obj, end, duration) {

        duringAnim = true;

        var start = parseInt(obj.text(), 10),
            range = end > start ? (start - end) : (end - start),
            current = start,
            increment;

        // increment by 10 if the number is large to save time
        if(range < -100) {
            increment = end > start ? 10 : -10;
        } else {
            increment = end > start ? 1 : -1;
        }

        var stepTime = Math.abs(Math.floor(duration / range));
        var timer = setInterval(function() {
            current += increment;
            obj.text(current);
            if (current == end) {
                clearInterval(timer);
            }
        }, stepTime);

        setTimeout(function() {
            duringAnim = false;
        }, 1000);
    }

    // Set up the calculator

    var joinOurTeam = (function() {

        var $calculatorOption = $('.js-calculator-option'),
            $suitsSoldContainer = $('.js-calculator-suits-sold'),
            $commissionContainer = $('.js-calculator-commission'),
            $payContainer = $('.js-calculator-pay');

        $calculatorOption.on('click', function() {

            if ( $(this).hasClass('is-current') || duringAnim ) {
                return false;
            }

            var $salesVolume = $(this).data('calculator-sales'),
                $suitsSold = $(this).data('calculator-suits-sold'),
                $commission = $(this).data('calculator-commission');

            // Style the active calculator option

            $(this).addClass('is-current');
            $calculatorOption.not($(this)).removeClass('is-current');

            // Do the math

            var suitsSoldResult = $suitsSold,
                commissionResult = parseInt($commission * 100),
                payResult = parseInt($salesVolume * $commission);

            // Animate for sexy results

            if (!!window.debug) {
                console.info("About to animate via animateValue", "suitsSoldResult=", suitsSoldResult, "commissionResult=", commissionResult, "payResult=", payResult)
            }

            animateValueImproved($suitsSoldContainer, suitsSoldResult, 500);
            animateValueImproved($commissionContainer, commissionResult, 500);
            animateValueImproved($payContainer, payResult, 1000);

        });

    }());

    var weddings = (function() {

        var $calculatorSelect = $('.js-calculator-select'),
            $calculatorRange = $('.js-calculator-range'),
            $calculatorOption = $('.js-calculator-option'),
            $priceContainer = $('.js-calculator-price');

        $calculatorSelect.change(function() {

            var selectedRange = $calculatorRange.find(':selected').data('calculator-range'),
                selectedOption = $calculatorOption.find(':selected').attr('data-calculator-' + selectedRange);

            if(selectedOption !== undefined) {
                $priceContainer.text(selectedOption);
                // animateValue($priceContainer, selectedOption, 1000);
                // animation function doesn't work on decimal numbers
            }

        });

    }());

}; // end of module.exports


// WEBPACK FOOTER //
// ./js-source/blocks/calculator.js